module.exports = __webpack_public_path__ + "img/slide12.f375bb98.png";